import {expensesRoute} from "../constants";
import {getApi} from "../get";
import {ExpensesGroupByCategory} from "../../types/ExpensesGroupByCategory";

export const getExpensesGroupByCategoryApi = async (params?: any): Promise<ExpensesGroupByCategory[]> => {
    return await getApi(expensesRoute, params);
}
